module.exports = __webpack_public_path__ + "static/img/18.0705e476.jpg";